import {createAsyncThunk, createSlice, isFulfilled, isPending, isRejected} from '@reduxjs/toolkit';
import {RootState} from '../../../../../Config/Store';
import axios from 'axios';
import {serializeAxiosError} from "../../../../../Config/Reducers/ReducerUtils";
import {DefaultState} from "../../../../../Config/Types";
import {PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {Alarm} from "../../AlarmReducer";

const initialState: DefaultState = {
    loading: false,
    saving: false,

    errorMessage: undefined,
    successMessage: undefined,

    entities: new Array<Alarm>(),
    entity: undefined,

    totalOfPages: 0,
    totalOfRecords: 0,
    totalOfRequestedRecords: 0,
    pageNumber: 0,
    recordsPerPage: 20,
};

const apiUrl = 'api/alarm/grouping/search';


export const searchEntitiesGroup = createAsyncThunk<
        any,
        {
            params: PagedSearchParams | undefined;
        }
    >(
    'alarms/grouping/search_entity',
    async ({params}) => {
        return axios.get(
            apiUrl,
            {
                params: params ? params.toURLSearchParams() : null
            }
        );

    },
    { serializeError: serializeAxiosError }
);

export const getEntity = createAsyncThunk<any, any, { rejectValue: any }>(
    'alarms/grouping/fetch_entity',
    async () => {
        return axios.get<Alarm>(`${apiUrl}`);
    },
    { serializeError: serializeAxiosError }
);

// Slices
const AlarmGroupingReducer = createSlice({
    name: 'AlarmGroupingReducer',
    initialState,
    reducers: {
        /**
         * Reset the entity state to initial state
         */
        resetGroup() {
            return initialState;
        },
        clearGroup: (state) => {
            state.entities = [];

        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder
            .addCase(getEntity.fulfilled, (state, action) => {
                state.loading = false;
                state.entity = action.payload.data.data;
            })
            .addMatcher(isFulfilled(searchEntitiesGroup), (state, action) => {
                state.loading = false;
                state.saving = false;

                state.successMessage = undefined;
                state.errorMessage = undefined;

                state.entities = action.payload.data.data;
                state.entity = undefined;

                state.totalOfPages = action.payload.data.totalOfPages;
                state.totalOfRecords = action.payload.data.totalOfRecords;
                state.totalOfRequestedRecords = action.payload.data.totalOfRequestedRecords;
                state.pageNumber = action.payload.data.pageNumber;
                state.recordsPerPage = action.payload.data.recordsPerPage;

            })
            .addMatcher(isPending(searchEntitiesGroup, getEntity), state => {
                state.loading = true;
                state.successMessage = undefined;
                state.errorMessage = undefined;
            })
            .addMatcher(isRejected(searchEntitiesGroup), (state:DefaultState, action) => {
                state.loading = false;
                state.successMessage = undefined;
                state.errorMessage = action.error.message;
            })
    },
})

export const { resetGroup, clearGroup } = AlarmGroupingReducer.actions;
export const selectAlarmGrouping = (state: RootState) => state.alarmGroupOverview;

// Reducer
export default AlarmGroupingReducer.reducer;